import styled from "styled-components";
import { COLORS } from "../../constants/colors";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

const PublicHeader = () => {
  const nav = useNavigate();

  const onClick = useCallback(() => {
    nav("/");
  }, []);

  return (
    <Container>
      <Logo
        onClick={onClick}
        src={require("../../assets/img/common/CloudnColorLogo.png")}
      />
    </Container>
  );
};

export default PublicHeader;

const Container = styled.div`
  width: 100%;
  height: 8%;
  background-color: ${COLORS.deepGray2};
`;

const Logo = styled.img`
  height: 100%;
  margin-left: 1%;
  cursor: pointer;
`;
